import { render, staticRenderFns } from "./active-request-tab-item.vue?vue&type=template&id=761ffe58&scoped=true&"
import script from "./active-request-tab-item.vue?vue&type=script&lang=js&"
export * from "./active-request-tab-item.vue?vue&type=script&lang=js&"
import style0 from "./active-request-tab-item.vue?vue&type=style&index=0&id=761ffe58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761ffe58",
  null
  
)

export default component.exports